import React from "react";
import GenderGeneralInfo from "../GeneralInfo";
import CardContainer from "../../../../components/Common/CardContainer";
import ButtonInput from "../../../../components/Common/ButtonInput";
import * as BootstrapVariants from "../../../../constants/Bootstrap/Variants";

const GenderDetails = (props) => {
  const handleReturn = () => {
    props.history.push(`/genders`);
  };
  return (
    <CardContainer
      header={"Gender Details"}
      backButton={
        <ButtonInput
          label="Back to List"
          type="button"
          variant={BootstrapVariants.OutlineSecondary}
          onClick={() => handleReturn()}
        />
      }
    >
      <GenderGeneralInfo genderId={props.match.params.genderId} />
    </CardContainer>
  );
};

export default GenderDetails;
